'use client';
/** @jsxImportSource @emotion/react */

import type { TableContainerProps as MuiTableContainerProps } from '@mui/material/TableContainer';

import MuiTableContainer from '@mui/material/TableContainer';

type ExcludedMuiProps = '';

interface TableContainerProps
  extends Omit<MuiTableContainerProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { TableContainerProps };
export const TableContainer: React.FC<TableContainerProps> = MuiTableContainer;

TableContainer.displayName = 'TableContainer';
